export default Object.freeze({
  HOLLOW: 'HOLLOW'
});